module.exports = __webpack_public_path__ + "static/img/zhihui-4.407af44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhihui-4.png
// module id = taWj
// module chunks = 46